// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
    IonButtons, IonHeader, IonMenuButton, IonToolbar
} from "@ionic/react"
import { useLocales } from "react-localized"
import CurrentUserMenu from "./CurrentUserMenu"
import HeaderLogo from "./HeaderLogo"
import useSession from './useSession'
import { useTheme } from "./useTheme"


interface MainToolbarProps {
  className?: string
  children?: React.ReactNode
  sideMenu?: boolean
}


const MainToolbar: React.FC<MainToolbarProps> = ({className, children, sideMenu}) => {
  const {user} = useSession()
  const {logo, name} = useTheme()
  const toolbarStyle: any = {}
  const {gettext} = useLocales()
  if (!sideMenu) {
    toolbarStyle["paddingLeft"] = "11px"
  }
  return (
    <IonHeader className={"main" + ((!!className) ? ` ${className}` : "")}>
      <IonToolbar style={toolbarStyle}>
          <IonButtons slot="start">
            <IonMenuButton autoHide={false}></IonMenuButton>
          </IonButtons>
        <div
          style={{
            display: "flex"
          }}
        >
          <HeaderLogo logo={logo} title={gettext(name)}/>
          <div
            style={{
              alignItems: "center",
              display: "flex",
              height: "100%"
            }}
          >
            {children}
          </div>
        </div>
        <IonButtons slot="end">
          <CurrentUserMenu user={user}/>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  )
}


export { MainToolbar}